import { render, staticRenderFns } from "./ImgTransfers.vue?vue&type=template&id=03be4e38&"
import script from "./ImgTransfers.vue?vue&type=script&lang=js&"
export * from "./ImgTransfers.vue?vue&type=script&lang=js&"
import style0 from "./ImgTransfers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports